import ABSLoading from '@abs/core/ABSLoading';
import ABSErrorBoundary from '@abs/core/ABSErrorBoundary';
import PropTypes from 'prop-types';
import { Suspense } from 'react';

/**
 * React Suspense defaults with Error Boundary for handling ChunkLoadErrors
 * For to Avoid Repetition
 */ function ABSSuspense(props) {
  return (
    <ABSErrorBoundary>
      <Suspense fallback={<ABSLoading {...props.loadingProps} />}>{props.children}</Suspense>
    </ABSErrorBoundary>
  );
}

ABSSuspense.propTypes = {
  loadingProps: PropTypes.object,
};

ABSSuspense.defaultProps = {
  loadingProps: {
    delay: 0,
  },
};

export default ABSSuspense;
